import React from 'react';

import moment from 'moment';
import { Input, Tooltip, Select, Button, Modal, Checkbox } from 'antd/lib';
import * as Icons from '@ant-design/icons';

import { Form } from '@ant-design/compatible';

import { withApollo } from 'react-apollo';
import _ from 'lodash';
import getUsuariosPorOrganismo from '../../../graphql/querys/auth/getUsuariosPorOrganismo.graphql';
import { errorService } from '../../../graphql/utils/utils';

// import SelectorModelo from './SelectorModelo'
const FormItem = Form.Item;
const Option = Select.Option;

class FormEditarOrganismo extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      loading: true,
      usuarios: [],
      confirmDirty: false,
      autoCompleteResult: [],
      requiredInputs: true,
    };

    // console.log("PORPS EN CONSST");
    // console.log(props);

    this.props.client
      .query({
        query: getUsuariosPorOrganismo,
        variables: { idOrganismo: props.datos._id },
      })
      .then(res => {
        const usuarios = res.data.getUsuariosPorOrganismo;
        // console.log("Respuesta exitosa!");
        // console.log(usuarios);

        this.setState({
          loading: false,
          usuarios,
        });
      })
      .catch(err => {
        console.log('Error en la creacion');
        console.log(err);
        errorService(err, {
          idOrganismo: props.datos._id,
        });
        Modal.error({
          title: 'Error en la inicializacion del componente grafico',
          content:
            'Lamentamos informarle que la operacion que intentó realizar, no se llevo a cabo por un error interno. Si el error persiste, comuniquesé con el departamento de informatica para obtener mas detalles.',
        });
      });
  }

  componentDidMount() {
    const { usuario } = this.props;
    if (usuario.rol === 'SUPERVISOR') {
      this.setState({ requiredInputs: false });
    }
  }

  handleSubmit = e => {
    e.preventDefault();
    this.props.form.validateFieldsAndScroll((err, values) => {
      if (!err) {
        this.props.onSubmit(values);
      }
    });
  };

  handleConfirmBlur = e => {
    const value = e.target.value;
    this.setState({ confirmDirty: this.state.confirmDirty || !!value });
  };

  checkConfirm = (rule, value, callback) => {
    const form = this.props.form;
    if (value && this.state.confirmDirty) {
      form.validateFields(['confirm'], { force: true });
    }
    callback();
  };

  crearOpciones(user) {
    return (
      <Option key={user._id} value={user._id}>
        {user.nombre + ' ' + user.apellido}
      </Option>
    );
  }

  render() {
    moment.locale('en');
    const { getFieldDecorator } = this.props.form;

    const formItemLayout = {
      labelCol: {
        xs: { span: 24 },
        sm: { span: 8 },
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 },
      },
    };
    const tailFormItemLayout = {
      wrapperCol: {
        xs: {
          span: 24,
          offset: 0,
        },
        sm: {
          span: 16,
          offset: 8,
        },
      },
    };

    const listaUsuarios = this.state.usuarios;
    if (listaUsuarios) {
      var opcionesUsuarios = _.map(listaUsuarios, this.crearOpciones);
    }

    return (
      <div>
        <h1 className="tituloForm">Organismo</h1>

        <Form onSubmit={this.handleSubmit} className="formularios">
          <FormItem {...formItemLayout} label={<span>Nombre</span>}>
            {getFieldDecorator('nombre', {
              rules: [
                {
                  required: this.state.requiredInputs,
                  message: 'Por favor, ingresar el nombre!',
                  whitespace: true,
                },
              ],
            })(<Input readOnly />)}
          </FormItem>

          <FormItem {...formItemLayout} label={<span>Telefono</span>}>
            {getFieldDecorator('telefono', {
              rules: [
                {
                  message: 'Por favor, ingresar el telefono!',
                  whitespace: true,
                },
              ],
            })(<Input />)}
          </FormItem>

          <FormItem {...formItemLayout} label={<span>Direccion</span>}>
            {getFieldDecorator('direccion', {
              rules: [
                {
                  required: this.state.requiredInputs,
                  message: 'Por favor, ingresar la direccion!',
                  whitespace: true,
                },
              ],
            })(<Input />)}
          </FormItem>

          <FormItem {...formItemLayout} label={<span>Ciudad</span>}>
            {getFieldDecorator('ciudad', {
              rules: [
                {
                  required: this.state.requiredInputs,
                  message: 'Por favor, ingresar la ciudad!',
                  whitespace: true,
                },
              ],
            })(<Input readOnly />)}
          </FormItem>

          <FormItem {...formItemLayout} label={<span>Circunscripción</span>}>
            {getFieldDecorator('circunscripcion', {
              rules: [
                {
                  required: this.state.requiredInputs,
                  message: 'Por favor, ingresar la circunscripcion!',
                  whitespace: true,
                },
              ],
            })(<Input />)}
          </FormItem>

          <FormItem {...formItemLayout} label={<span>Email</span>}>
            {getFieldDecorator('email', {
              rules: [
                {
                  required: this.state.requiredInputs,
                  message: 'Por favor, ingresar el email!',
                  whitespace: true,
                },
              ],
            })(<Input addonAfter="@jusneuquen.gov.ar" />)}
          </FormItem>

          <FormItem
            {...formItemLayout}
            label={<span>Codigo del Organismo</span>}
          >
            {getFieldDecorator('codigoOrganismo', {
              rules: [
                {
                  required: this.state.requiredInputs,
                  message: 'Por favor, ingresar el codigo del organismo!',
                  whitespace: true,
                },
              ],
            })(<Input />)}
          </FormItem>

          <FormItem
            {...formItemLayout}
            label={
              <span>
                Juez a cargo
                <Tooltip title="Seleccione el juez a cargo del organismo">
                  <Icons.QuestionCircleOutlined />
                </Tooltip>
              </span>
            }
          >
            {getFieldDecorator('idResponsable', {
              rules: [
                {
                  required: this.state.requiredInputs,
                  message: 'Por favor, ingrese el responsable!',
                },
              ],
            })(
              <Select
                showSearch
                style={{ width: 500 }}
                placeholder="Seleccione un responsable"
                optionFilterProp="children"
                filterOption={(input, option) =>
                  option.props.children
                    .toLowerCase()
                    .indexOf(input.toLowerCase()) >= 0
                }
              >
                {opcionesUsuarios}
              </Select>
            )}
          </FormItem>

          <FormItem
            {...formItemLayout}
            label={
              <span>
                Acceso a la OV
                <Tooltip title="Seleccione si el organismo tiene acceso a la Oficina de Violencia">
                  <Icons.QuestionCircleOutlined />
                </Tooltip>
              </span>
            }
          >
            {getFieldDecorator('conectaOV', {
              valuePropName: 'checked',
            })(<Checkbox />)}
          </FormItem>

          <FormItem {...tailFormItemLayout}>
            <Button type="primary" htmlType="submit">
              Confirmar
            </Button>
            <Button type="danger" onClick={this.props.onAnterior}>
              Cancelar
            </Button>
          </FormItem>
        </Form>
      </div>
    );
  }
}

export default Form.create({
  mapPropsToFields(props) {
    // console.log('props', props);
    return {
      nombre: Form.createFormField({
        value: props.datos ? props.datos.nombre : '',
      }),
      ciudad: Form.createFormField({
        value: props.datos ? props.datos.ciudad : '',
      }),
      direccion: Form.createFormField({
        value: props.datos ? props.datos.direccion : '',
      }),
      circunscripcion: Form.createFormField({
        value: props.datos ? props.datos.circunscripcion : '',
      }),
      telefono: Form.createFormField({
        value: props.datos ? props.datos.telefono : '',
      }),
      email: Form.createFormField({
        value: props.datos ? props.datos.email : '',
      }),
      codigoOrganismo: Form.createFormField({
        value: props.datos ? props.datos.codigoOrganismo : '',
      }),
      idResponsable: Form.createFormField({
        value:
          props.datos && props.datos.responsable
            ? props.datos.responsable._id
            : '',
      }),
      conectaOV: Form.createFormField({
        value: props.datos ? props.datos.conectaOV : false,
      }),
    };
  },
})(withApollo(FormEditarOrganismo));
